import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AmplitudeService } from '../../services/amplitude.service';
import { AuthService } from '../../services/auth.service';
import { SnackbarService } from '../../services/snackbar.service';

@Component({
  selector: 'app-restore',
  templateUrl: './restore.component.html',
  styleUrls: ['./restore.component.scss'],
  standalone: false,
})
export class RestoreComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;

  username: string;
  password: string;
  confirmPassword: string;
  code: string;
  hidePassword: boolean = true;
  hideConfirmPassword: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private snackBar: SnackbarService,
    private authService: AuthService,
    private router: Router,
    private amplitudeService: AmplitudeService,
  ) {
    this.code = this.route.snapshot.params['token'];
  }

  ngOnInit(): void {}

  restore() {
    if (!this.password || !this.username || !this.confirmPassword) {
      this.snackBar.warning('Por favor, rellena todos los campos.');
      return;
    }

    if (this.password !== this.confirmPassword) {
      this.snackBar.warning('La contraseña y su confirmación no coinciden.');
      return;
    }

    this.blockUI.start();

    this.authService
      .restorePassword(
        this.username.trim().toLowerCase(),
        this.password,
        this.code,
      )
      .then(() => {
        this.blockUI.stop();
        this.snackBar.success('Has cambiado tu contraseña correctamente');
        this.router.navigate(['/login']);
        this.amplitudeService.logEvent('RememberSuccess', {
          result: 'success',
        });
      })
      .catch((error) => {
        this.blockUI.stop();
        this.snackBar.error(error.message);
      });
  }

  reset() {
    if (!this.username) {
      this.snackBar.warning('Por favor, rellena todos los campos.');
      return;
    }

    this.blockUI.start();

    this.authService
      .resetPassword(this.username.trim().toLowerCase())
      .then(() => {
        this.blockUI.stop();
        this.snackBar.success('Revisa tu correo electrónico');
        this.amplitudeService.logEvent('RememberRequested', {
          result: 'success',
        });
      })
      .catch((error) => {
        this.blockUI.stop();
        this.snackBar.error(error.message);
      });
  }
}
